<template>
    <div class="input_name" v-if="showInput">
        <div class="mask"></div>
        <div class="container">
            <div class="desc">
                <p >输入您的名字<em>（用来生成证书）</em></p>
                <p class="close" @click="closed">取消</p>
            </div>
            <span></span>
            <input type="text" ref="name">
            <div class="butten" @click="creatCard">生成证书</div>
            <div class="toast" v-if="toast">{{message}}</div>
        </div>
    </div>
</template>
<script>
    import { SENSEWORDS } from './../libs/sensitiveWords.js'
    export default {
        name: 'Home',
        data () {
            return {
                toast: false,
                message: ''
            }
        },
        props: {
            showInput: ''
        },
        
        methods: {
            closed: function () {
                this.$emit('closedInput', false)
            },
            creatCard: function () {
                let that = this
                let name = this.$refs.name.value
                if (this.checkName(name)) {
                    this.$emit('getName')
                    this.$store.commit('USERNAME', name)
                } else {
                    this.checkName(name)
                }
            },
            checkName: function (name) {
                let that = this
                if (name === "") {
                    this.message = '请您输入名字'
                    that.toast = true
                    setTimeout(() => {
                        that.toast = false
                    }, 2000);
                    return false
                }
                if (!/^[a-zA-Zu4E00-\u9FA5\s]+$/g.test(name)) {
                    this.message = '只允许输入中英文'
                    that.toast = true
                    setTimeout(() => {
                        that.toast = false
                    }, 2000);
                    return false
                }
                if (this.getStrlen(name) > 8) {
                    this.message = '姓名最长允许8个汉字或16个英文字母'
                    that.toast = true
                    setTimeout(() => {
                        that.toast = false
                    }, 2000);
                    return false
                }
                if (SENSEWORDS.indexOf(name) > -1) {
                    this.message = '请换一个名字试试看'
                    that.toast = true
                    setTimeout(() => {
                        that.toast = false
                    }, 2000);
                    return false
                }
                return true
            },
            getStrlen: function (str) {
                let len = 0
                for (let i = 0; i < str.length; i++) {
                    if (str.charCodeAt(i) >= 65 && str.charCodeAt(i) <= 122) {
                        len++
                    } else {
                        len += 2
                    }
                }
                return len;
            }

        }
    }
</script>

<style>
    .input_name {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
    .input_name .mask{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #000;
        opacity: 0.5;
    }
    .input_name .container {
        width: 6.7rem;
        height: 4.2rem;
        position: fixed;
        top: 3.32rem;
        left: 50%;
        margin-left: -3.35rem;
        background: rgba(255,255,255,1);
        border-radius: 6px;
        border: 1px solid rgba(225,225,225,1);
    }
    .input_name .desc {
        height: 0.32rem;
        margin: 0.5rem 0.3rem 0.4rem 0.4rem
    }
    .input_name p {
        font-size: 0.32rem;
        font-family: PingFangSC-Semibold;
        color: rgba(72,78,94,1);
        line-height: 0.32rem;
        float: left;
    }
    .input_name em {
        font-size: 0.28rem;
        font-family: PingFangSC-light;
        color: rgba(72,78,94,1);
        line-height: 0.32rem;
        font-style: normal;
    }
    .input_name .desc .close {
        float: right;
        font-size: 0.3rem;
        font-family: PingFangSC-Regular;
        color: rgba(144,148,158,1);
        line-height: 0.32rem;
    }
    .input_name span {
        display: block;
        width: 5.9rem;
        margin: 0 auto 0.4rem;
        opacity: 0.1;
        border-bottom: 1px solid rgba(72,78,94,1);
    }
    .input_name input {
        width: 5.9rem;
        height: 0.78rem;
        line-height: 0.78rem;
        border-radius: 0.06rem;
        display: block;
        margin: 0 auto 0.5rem;
        font-size: 0.32rem;
        box-sizing: border-box;
        padding-left: 0.2rem;
        opacity: 0.7378;
        border: 1px solid rgba(182,184,191,1);
    }
    .input_name .butten {
        width: 5.50rem;
        height: 0.9rem;
        background: linear-gradient(135.4deg,rgba(255,175,36,1),rgba(255,138,38,1),rgba(255,135,38,1),rgba(255,135,38,1));
        box-shadow: 0 0.04rem 0.11rem 0 rgba(254,187,97,0.36);
        border-radius: 1rem;
        margin: 0 auto;
        font-size: 0.32rem;
        font-family: PingFangSC-Regular;
        color: rgba(255,255,255,1);
        line-height: 0.9rem;
        text-align: center;
    }
    .toast {
        width: 5.16rem;
        height: 1.4rem;
        background: rgba(72,78,94,1);
        border-radius: 0.33rem;
        font-size: 0.32rem;
        font-family: PingFangSC-Semibold;
        color: rgba(255,255,255,1);
        position: fixed;
        top: 4.6rem;
        left: 50%;
        margin-left: -2.58rem;
        text-align: center;
        line-height: 1.4rem;
        opacity: 0.7;
    }
</style>



// WEBPACK FOOTER //
// src/components/InputName.vue